<template>
<div class="modal-card">
  
  <header class="modal-card-head">
    <p class="modal-card-title">You are an expert, right?</p>
  </header>
  
  <section class="modal-card-body">
    <div class="content">
      <p>Sometimes the Pixxies get it wrong. Of course we punish them,
      but in the meantime you can paper over some of their misdeeds manually.</p>
      <b-field label="Options:">
        <b-collapse class="card" collapsible :open="false">
          <div slot="trigger" slot-scope="props" class="card-header">
            <p class="card-header-title">Small Tweaks, Applied Globally</p>
            <a class="card-header-icon"><b-icon :icon="props.open?'menu-up':'menu-down'"></b-icon></a>
          </div>
          <div class="card-content" style="width: 100%;">
            <div v-for="t,k in tweaksAvailable">
              <b-checkbox v-model="tweaks[k]"> {{t.label}}
                <b-tooltip v-if="t.hint" class="hint"
                           type="is-dark" multilined
                           :label="t.hint">
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
                </b-tooltip>
              </b-checkbox>
            </div>
          </div>
        </b-collapse>
      </b-field>
      <b-field v-if="devMode">
        <b-collapse class="card dev-only" collapsible :open="false">
          <div slot="trigger" slot-scope="props" class="card-header">
            <p class="card-header-title">Dev Support Settings</p>
            <a class="card-header-icon"><b-icon :icon="props.open?'menu-up':'menu-down'"></b-icon></a>
          </div>
          <div class="card-content" style="width: 100%;">
            <div v-for="t,k in devTweaks">
              <b-checkbox v-model="tweaks[k]"> {{t.label}}
                <b-tooltip v-if="t.hint" class="hint"
                           type="is-dark" multilined
                           :label="t.hint">
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
                </b-tooltip>
              </b-checkbox>
            </div>
            <!--b-checkbox v-model="forceRebuild"> Force rebuild of the
              entire book preview
                <b-tooltip class="hint"
                           type="is-dark" multilined
                           label="Careful! This may take a while. Do
                           this only if you think the preview has not
                           updated correctly which shouldn't happen. If
                           you find that this is the case, please
                           contact our helpline.">
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
                </b-tooltip>
            </b-checkbox-->
          </div>
        </b-collapse>
      </b-field>
      </b-field>
      <b-field label="Language for dates and hyphenation">
        <select v-model="locale">
          <option v-for="(desc,loc) in locales" :value="loc" v-html="desc"/>
        </select>
      </b-field>
      <b-field label="Feeling super empowered? Try the...">
        <b-collapse class="card" collapsible :open="false">
          <div slot="trigger" slot-scope="props" class="card-header">
            <p class="card-header-title">Superhero Self Help Zone</p>
            <a class="card-header-icon"><b-icon :icon="props.open?'menu-up':'menu-down'"></b-icon></a>
          </div>
          <div class="card-content" style="width: 100%;">
            <b-field label="CSS Overides:">
              <b-input v-model="userCss" type="textarea" rows="4" expanded
                       placeholder=".content .annoying-ads { display: none !important;}">
              </b-input>
            </b-field>
          </div>
        </b-collapse>
      </b-field>
    </div>
  </section>

  <footer class="modal-card-foot">
    <div class="level">
      <div class="level-left"> </div>
      <div class="level-right">
        <button class="button" @click="cancel">Cancel</button>
        <button class="button is-primary" @click="done">Done</button>
      </div>
    </div>
  </footer>
</div>
</template>

<script>
import ActionLog from '../actionlog.js'
import Firebase from '../firebase.js'
var db = Firebase.database

const BasicTweaks = {
  no_dark_backgrounds: { label: 'No dark page packgrounds',
                         hint: 'Use a white page for polaroid style images instead of the default grey/black' ,
                         css: `.page.backdrop {
                             background-color: inherit !important;
                          }` },
}

const BlogTweaks = {
  hide_byline: { label: 'Hide date and author for each post',
                 css: 'article .byline { visibility: hidden; }' },
  show_author: { label: 'Show author for each post',
                 css: 'article .byline .author { display: inline !important; }'},
  hide_video:  { label: 'Hide video thumbnails and QR code',
                 css: 'article .pixxi-vid-holder { display: none; }' },
  //hide_bullets: { label: 'Hide bullets (sometimes left behind by image gallery)',
  //               css: 'article ul { display: none; }' },
  uniform_fonts: { label: 'Override blog fonts',
                   hint: 'Use our lovely serif font for all content even if the blog specifies something else.',
                   css: `article .content p,
                         article .content span,
                         article .content font,
                         article .content div,
                         article .content b,
                         article .content i,
                         article .content u,
                         article .content li {
                           font-family: "Crimson Pro", Amiri,
                                        "Noto Serif KR", "Noto Serif JP",
                                        "Noto Serif SC", "Noto Serif TC", serif !important;
                           font-size: 18px !important;
                         }` },
  uniform_colors: { label: 'Override blog text colors',
                    hint: 'Use standard black on white font for all content even if the blog specifies something else.',
                    css: `article .content h1,
                          article .content h2,
                          article .content h3,
                          article .content h4,
                          article .content h5,
                          article .content h6,
                          article .content p,
                          article .content span,
                          article .content font,
                          article .content div,
                          article .content b,
                          article .content i,
                          article .content u,
                          article .content li {
                          background-color: transparent !important;
                          color: black !important;
                          }` },
}

const InstagramTweaks = {
  hide_byline: { label: 'Hide date for each post',
                 css: 'article .byline { visibility: hidden; }' },
  hide_post_titles: { label: 'Don\'t show placename in post titles',
                      hint: 'Usually we use the post location as the title if available.',
                      css: 'article .title h2 { display: none; }' },
  show_trailing_hashtags: { label: 'Show trailing hashtags',
                            hint: 'Usually we omit any hashtags at the end of the caption.',
                            css: `.content .trailing-hashtags
                                  { display: initial !important; }` },
  hide_video_qr:  { label: 'Hide post link QR code',
                    css: 'article .title .pixxi-qrlink { display: none !important; }' },
  //show_likes: 
}

const DevTweaks = {
  hide_author: { label: 'Hide post author (older books)',
                 css: 'article .byline .author { display: none; }' },
  disable_hyphenation: { label: 'Disable hyphenation',
                         css: '.content-flow-source { hyphens: none !important; }' },
  squeeze_title_blurb: { label: 'Squeeze title page blurb',
                         css: '#titlepage #blurb { font-size: 20px !important; }' },
  squeeze_subtitle: { label: 'Squeeze SubTitle',
                      css: `#frontcover #subtitle,
                            #titlepage #subtitle
                            { font-size: 120% !important; }` },
  no_bleed_images: { label: 'Keep images from the page edges',
                     hint: 'Tries to avoid running images into the bleed and minimise cropping. May have side-effects.' ,
                     css: `.page[pixxi-template=full_page_image] .captioned-image img {
                             max-height: 85% !important;
                             max-width: 85% !important;
                          }` },
  rtl_language: { label: 'Format for right-to-left language',
                  hint: '!! cover still needs re-ordering and pages need reversing !!',
                  css: `.title { direction: rtl !important; right: 0px !important; text-align: right !important; }' +
                         .content { direction: rtl !important; }
                         .hlayout { /* columns */  flex-direction:  row-reverse !important;  }`
                },
  page_numbers: { label: 'EXPERIMENTAL: include page numbers',
                  hint: '!! note preview only has placeholder numbers - actual page numbers will be caculated at production !!',
                  css: '.page-number { display: block; }' },
  table_of_contents: { label: 'EXPERIMENTAL: include table_of_contents',
                       hint: '!! note preview only has placeholder table - actual contents will be caculated at production !!',
                       css: '/*table of contents : no css*/' },
  cache_all_images: { label: 'DEV ONLY: cache all images with insta_proxy',
                      hint: '!! DEV ONLY !!',
                      css: '/*cache all images : no css*/' },
} 

const Locales = {
  en_US: 'English (US)',
  en_GB: 'English (GB)',
  fr: 'French (Fran&#231;ais)',
  de: 'German (Deutsch)',
  da: 'Danish (Dansk)',
  es: 'Spanish (Espa&ntilde;ol)',
  it: 'Italian (Italiano)',
  nb_NO: 'Norwegian (Norsk nynorsk)',
  nl: 'Dutch (Nederlands)',
  pl: 'Polish (Polski)',
  pt: 'Portuguese (Portugu&ecirc;s)',
  sv: 'Swedish (Svenska)',
  
}

function hashCode(s) {
  var h = s.split("").reduce(function(a,b){a=((a<<5)-a)+b.charCodeAt(0);return a&a},0)
  return h < 0 ? -h : h
}


export default {
  name: 'ExpertMode',
  data: function() { return {
    originalCss: '',
    userCss: '',
    tweaks: {},
    originalLocale: '',
    locale: '',
    locales: Locales,
    forceRebuild: false,
  }},
  props: {
    projid: { type: String, required: true },
  },
  computed: {
    devMode: function() {
      return this.$store.state.dev.developmentClient
    },
    extraCss: function() {
      const allTweaks = Object.assign({},this.tweaksAvailable,this.devTweaks)
      var tweakCss = Object.keys(this.tweaks).map( k => this.tweaks[k] ? (allTweaks[k] || {}).css : '' )
      var css = tweakCss.join('\n')
      if (this.userCss) {
        css += '\n\n/***USER**/\n\n' + (this.userCss || '/* -none- */') +  '\n'
      }
      if (this.forceRebuild) {
        // add timestamp to force change of styleHash and hence rebuild
        css += '\n\n/*** FORCE REBUILD @'+ Date.now() +'**/\n\n'
      }
      return css
    },
    tweaksList: function() {
      return Object.keys(this.tweaks).filter( k => this.tweaks[k] ).join(',')
    },
    tweaksAvailable: function() {
      const isInsta = this.projid.toLowerCase().includes('instagram')
      return Object.assign({},
                           BasicTweaks,
                           isInsta ? InstagramTweaks : BlogTweaks)
    },
    devTweaks: function() {
      return DevTweaks
    },
  },
  methods: {
    cancel: function() {
      this.$parent.close()
      console.log('expertMode: ', this.extraCss)
    },
    done: function() {
      if (this.extraCss != this.originalCss
          || this.locale != this.originalLocale) {
        // include locale in hash to force refresh on change
        var cssHash = hashCode(this.extraCss + '/*'+this.locale+'*/')
        var update = { userCss: this.userCss || '',
                       extraCss: this.extraCss,
                       styleHash: cssHash ? cssHash.toString() : null,
                       tweaks: this.tweaksList,
                       locale: this.locale }
        this.$firebaseRefs.selections.update(update)

        if (this.forceRebuild) {
          ActionLog('preview_rebuild', {bookid: this.projid})
        }
      }

      this.$parent.close()
    },
  },
  watch: {
  },
  beforeMount: function() {
    var path = "/projects/"+this.$store.state.uid+"/"+this.projid+"/selections"
    var selref = db.ref(path)
    this.$bindAsObject("selections", selref)
    
    selref.once("value", snap => {
      var selections = snap.val()
      if (selections) {
        this.originalCss = selections.extraCss
        this.originalLocale = selections.locale || 'en_US'
        this.locale = this.originalLocale
        this.userCss = selections.userCss
        if (selections.tweaks) {
          this.tweaks = selections.tweaks.split(',')
            .reduce( (o,i) => { o[i] = true; return o }, {})
        }
      }
    })
  }
}
</script>

<style scoped>
.level {
    width: 100%;
}
.button {
    min-width: 8em;
}
.hint {
    color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/ExpertMode.vue